import $ from "jquery";
let csrfSetup;
let Dispatcher;
let EventEmitter;
let Metrics;
let StripeStore;
let UserStore;
let noun_user;
let url_to_array;
const bind = (fn, me) =>
    function(...args) {
        return fn.apply(me, args);
    };

csrfSetup = require("../helpers/csrf_setup").default;

EventEmitter = require("events").EventEmitter;

Dispatcher = require("../dispatcher/dispatcher").default;

Metrics = require("../helpers/metrics").default;

noun_user = require("../helpers/noun_user").default;

url_to_array = require("../helpers/url_to_array").default;

UserStore = require("../stores/userstore").default;

StripeStore = (() => {
    class StripeStore {
        constructor() {
            this.update_card = bind(this.update_card, this);
            this.can_update_card = bind(this.can_update_card, this);
            this.plans = {
                pro: {
                    monthly: {
                        price: "9.99"
                    },
                    yearly: {
                        price: "39.99"
                    }
                },
                team: {
                    monthly: {
                        price: "9.99"
                    },
                    yearly: {
                        price: "39.99"
                    }
                }
            };
            this._emitter = new EventEmitter();
            this._statuses = {
                WAITING: "WAITING",
                PROCESSING: "PROCESSING",
                SUCCESS: "SUCCESS",
                FAILURE: "FAILURE",
                COMPLETE: "COMPLETE"
            };
            this._data = {};
            this._errors = {};
            this._user = {};
            this.initialize();
            this._dispatchToken = Dispatcher.register(
                (_this => payload => {
                    let is_validated;
                    switch (payload.actionType) {
                        case "startBillingSubmit":
                            _this._currentStatus = "PROCESSING";
                            _this._user = UserStore.getAll().user;
                            _this._data = payload.data;
                            _this._errors = {};
                            _this.emitEvent("change");
                            if (payload.card !== void 0) {
                                if (_this._data.save_card === "on") {
                                    _this._user.has_credit_card = false;
                                } else {
                                    is_validated = true;
                                }
                            }
                            if (_this._user.has_credit_card) {
                                if (_this._data.plan === "a-la-carte") {
                                    if (is_validated === true) {
                                        return _this.a_la_carte({
                                            icon_id: _this._data.icon.id,
                                            receipt_info:
                                                _this._data.receipt_info
                                        });
                                    } else {
                                        _this.is_validated();
                                        return _this.emitEvent("change");
                                    }
                                } else {
                                    if (is_validated === true) {
                                        return _this.subscribe();
                                    } else {
                                        _this.is_validated();
                                        return _this.emitEvent("change");
                                    }
                                }
                            } else {
                                _this.set_publishable_key();
                                is_validated = _this.is_validated();
                                if (is_validated === true) {
                                    return _this.get_token();
                                } else {
                                    return _this.emitEvent("change");
                                }
                            }
                            break;
                        case "cardUpdated":
                            if (_this._data.plan === "a-la-carte") {
                                return _this.a_la_carte({
                                    icon_id: _this._data.icon.id,
                                    receipt_info: _this._data.receipt_info
                                });
                            } else if (_this._data.plan === "update") {
                                _this._data = {
                                    updated: "okay"
                                };
                                return _this.emitEvent("change");
                            } else {
                                return _this.subscribe();
                            }
                            break;
                        case "confirmCharge":
                            if (_this._currentStatus === "SUCCESS") {
                                _this._data.charge = void 0;
                                _this._currentStatus = "COMPLETE";
                                return _this.emitEvent("change");
                            } else if (_this._currentStatus === "FAILURE") {
                                _this._currentStatus = "WAITING";
                                return _this.emitEvent("change");
                            }
                            break;
                        case "abortDownload":
                            return _this.initialize();
                    }
                })(this)
            );
        }

        initialize() {
            this._data.charge = null;
            this._currentStatus = "WAITING";
            return this.emitEvent("change");
        }

        emitEvent(eventName, data) {
            if (data == null) {
                data = null;
            }
            if (data !== null) {
                return this._emitter.emit(eventName, data);
            } else {
                return this._emitter.emit(eventName);
            }
        }

        addListener(eventName, callback) {
            return this._emitter.on(eventName, callback);
        }

        removeListener(eventName, callback) {
            return this._emitter.removeListener(eventName, callback);
        }

        getCurrentStatus() {
            return this._currentStatus;
        }

        check_for_errors(data) {
            if (data.errors && data.errors.error && data.errors.error.code) {
                switch (data.errors.error.code) {
                    case "card_declined":
                        this._errors.card_number = data.errors.error.message;
                        break;
                    case "processing_error":
                        this._errors.card_number = data.errors.error.message;
                        break;
                    case "expired_card":
                        this._errors.card_number = data.errors.error.message;
                        break;
                    case "incorrect_cvc":
                        this._errors.card_cvc = data.errors.error.message;
                        break;
                    default:
                        this._errors[data.errors.error.code] =
                            data.errors.error.message;
                        this._errors.general = data.errors.error.message;
                }
                this._currentStatus = "FAILURE";
                return this.emitEvent("change");
            }
        }

        is_validated() {
            if (this._data.card_name === "") {
                this._errors.card_name =
                    "You must provide the name of the card holder.";
                this._currentStatus = "FAILURE";
            }
            if (!Stripe.card.validateCardNumber(this._data.card_number)) {
                this._errors.card_number = "Your card was declined.";
                this._currentStatus = "FAILURE";
                return false;
            }
            if (
                !Stripe.card.validateExpiry(
                    this._data.card_exp_month,
                    this._data.card_exp_year
                )
            ) {
                this._errors.card_expiration = "Invalid expiration date";
                this._currentStatus = "FAILURE";
                return false;
            }
            if (!Stripe.card.validateCVC(this._data.card_cvc)) {
                this._errors.card_cvc =
                    "Your card’s security code is incorrect.";
                this._currentStatus = "FAILURE";
                return false;
            }
            return true;
        }

        get_token() {
            let token;
            csrfSetup();
            return (token = Stripe.card.createToken(
                {
                    number: this._data.card_number,
                    cvc: this._data.card_cvc,
                    exp_month: this._data.card_exp_month,
                    exp_year: this._data.card_exp_year,
                    name: this._data.card_name,
                    receipt_info: this._data.receipt_info
                },
                this.can_update_card
            ));
        }

        get(key) {
            return this._data[key];
        }

        getAll() {
            return this._data;
        }

        set_publishable_key() {
            return Stripe.setPublishableKey(this._user.stripe);
        }

        can_update_card(status, response) {
            if (status === 200) {
                this._data.stripe_token = response.id;
                if (this._data.plan === "a-la-carte") {
                    if (this._data.save_card === "on") {
                        return this.update_card({
                            stripe_token: this._data.stripe_token,
                            receipt_info: this._data.receipt_info,
                            seats: this._data.seats,
                            coupon: this._data.coupon,
                            next: this._data.next
                        });
                    } else {
                        return this.a_la_carte({
                            icon_id: this._data.icon.id,
                            stripe_token: this._data.stripe_token,
                            receipt_info: this._data.receipt_info
                        });
                    }
                } else {
                    this._data = {
                        stripe_token: this._data.stripe_token,
                        receipt_info: this._data.receipt_info,
                        plan: this._data.plan,
                        seats: this._data.seats,
                        coupon: this._data.coupon,
                        next: this._data.next
                    };
                    return this.update_card(this._data);
                }
            } else if (status === 402) {
                this._errors.card_number =
                    "We could not process your payment. Please try again later.";
                this._currentStatus = "FAILURE";
                return new Metrics().failed_upgrade(noun_user.id, response);
            } else {
                this._errors.card_number =
                    "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (status " +
                    status.toString() +
                    ")' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                this._currentStatus = "FAILURE";
                return new Metrics().failed_upgrade(noun_user.id, response);
            }
        }

        update_card(data) {
            let me;
            me = this;
            return $.ajax({
                url:
                    "//" +
                    url_to_array[2] +
                    "/" +
                    this._user.username +
                    "/card/update/",
                type: "POST",
                data,
                success(data, status, xhr) {
                    me.check_for_errors(data);
                    if (!data.errors) {
                        Dispatcher.dispatch({
                            actionType: "cardUpdated"
                        });
                        return Dispatcher.dispatch({
                            actionType: "updateUser",
                            card: {
                                card_cvc: me._data.card_cvc,
                                card_name: me._data.card_name,
                                ok: true,
                                card_number: me._data.card_number,
                                card_expiration: me._data.card_expiration
                            },
                            updateCard: true
                        });
                    }
                },
                error(xhr, status, error) {
                    me._errors.card_number =
                        "We could not update your card. Please try again later.";
                    me._currentStatus = "FAILURE";
                    return me.emitEvent("change");
                }
            });
        }

        subscribe(data) {
            let me;
            let url;
            me = this;
            if (this._data.plan.indexOf("pro") === 0) {
                url =
                    "//" +
                    url_to_array[2] +
                    "/" +
                    this._user.username +
                    "/subscribe/pro/";
            } else if (this._data.plan.indexOf("team") === 0) {
                url =
                    "//" +
                    url_to_array[2] +
                    "/" +
                    this._user.username +
                    "/subscribe/team/";
            }
            return $.ajax({
                url,
                type: "POST",
                data: this._data,
                success(data, status, xhr) {
                    if (!data.errors) {
                        me._data.charge = data.subscription;
                        me.emitEvent("change");
                        Dispatcher.dispatch({
                            actionType: "subscribePayment",
                            plan: me._data.plan
                        });
                        new Metrics().upgrade(data);
                    } else {
                        me._errors = data.errors;
                        me.emitEvent("change");
                        new Metrics().failed_upgrade(noun_user.id, data);
                    }
                    return (me._currentStatus = "SUCCESS");
                },
                error(xhr, status, error) {
                    if (status === 402) {
                        me._errors.card_number =
                            "We could not process your payment. Please try again later.";
                        new Metrics().failed_upgrade(
                            noun_user.id,
                            xhr.responseText
                        );
                    } else {
                        me._errors.card_number =
                            "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (status " +
                            status.toString() +
                            ")' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                        new Metrics().failed_upgrade(
                            noun_user.id,
                            xhr.responseText
                        );
                    }
                    me._currentStatus = "FAILURE";
                    me.emitEvent("change");
                }
            });
        }

        a_la_carte(data) {
            let me;
            let purchase_data;
            me = this;
            purchase_data = {
                company_name: data.company_name,
                vat: data.vat
            };
            if (data.stripe_token) {
                purchase_data.stripe_token = data.stripe_token;
            }
            return $.ajax({
                type: "POST",
                data: purchase_data,
                url:
                    "//" +
                    url_to_array[2] +
                    "/icon/" +
                    data.icon_id +
                    "/purchase/",
                success(data, status, xhr) {
                    me.check_for_errors(data);
                    if (!data.errors) {
                        me._errors = {};
                        me._data.charge = data.charge;
                        me._currentStatus = "SUCCESS";
                        me.emitEvent("change");
                        Dispatcher.dispatch({
                            actionType: "aLaCartePayment"
                        });
                        return new Metrics().record_purchase();
                    } else {
                        me.emitEvent("change");

                        // Only send unusual errors to sentry
                        if (me._errors.general) {
                            new Metrics().failed_alacarte(noun_user.id, data);
                        }
                        return (me._currentStatus = "FAILURE");
                    }
                    return (me._currentStatus = "SUCCESS");
                },
                error(xhr, status, error) {
                    if (status === 402) {
                        me._errors.card_number =
                            "We could not process your payment. Please try again later.";
                        new Metrics().failed_alacarte(
                            noun_user.id,
                            xhr.responseText
                        );
                    } else {
                        me._errors.card_number =
                            "Something went wrong. Please contact <a href='mailto:info@thenounproject.com?subject=Failed upgrade (status " +
                            status.toString() +
                            ")' title='info@thenounproject.com'>info@thenounproject.com</a> for help";
                        new Metrics().failed_alacarte(
                            noun_user.id,
                            xhr.responseText
                        );
                    }
                    me._currentStatus = "FAILURE";
                    me.emitEvent("change");
                }
            });
        }
    }

    return StripeStore;
})();

export default new StripeStore();
